import { recordPath, recordRoute } from '@/shared/registry'

/** Where My Messages lives. */
export const myMessagesPath = '/notifications/my-messages'
export const myMessageRoute = recordRoute('notifications', 'my-messages')

/** One of the caller's messages. */
export function myMessagePath(id: string): string {
  return recordPath('notifications', 'my-messages', id)
}

/** The base of My Message's details slots (`detailsSlots`). */
export const myMessageDetailsSlot = 'notifications.my-message-details'

/** The permission My Messages needs; everyone holds it for their own messages. */
export const readSentMessagesPermission = 'notifications.sent-message.read'

/** The API's endpoints for the caller's messages. */
export const myMessagesApi = '/notifications/v1/me/messages'
export const unreadCountApi = `${myMessagesApi}/unread-count`

export function myMessageApi(id: string): string {
  return `${myMessagesApi}/${encodeURIComponent(id)}`
}

export function myMessageReadApi(id: string): string {
  return `${myMessageApi(id)}/read`
}
